(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.related-products-section');

    sections.forEach(section => {
      const container = section.querySelector('.related-products-slider__container');
      const track = section.querySelector('.related-products-slider__track');
      const prevButton = section.querySelector('.slider-button--prev');
      const nextButton = section.querySelector('.slider-button--next');
      
      if (!track) return;

      const slides = track.querySelectorAll('.related-product__slide');
      if (slides.length === 0) return;

      let currentIndex = 0;
      const totalSlides = slides.length;

      function getSlidesToShow() {
        if (window.innerWidth <= 768) return 2;
        if (window.innerWidth <= 990) return 3;
        return 4;
      }

      function updateSliderPosition() {
        const slideWidth = slides[0].offsetWidth;
        track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
      }

      function moveToNextSlide() {
        const slidesToShow = getSlidesToShow();
        if (totalSlides <= slidesToShow) return;
        
        if (currentIndex < totalSlides - slidesToShow) {
          currentIndex++;
        } else {
          currentIndex = 0;
        }
        updateSliderPosition();
      }

      function moveToPrevSlide() {
        const slidesToShow = getSlidesToShow();
        if (totalSlides <= slidesToShow) return;

        if (currentIndex > 0) {
          currentIndex--;
        } else {
          currentIndex = totalSlides - slidesToShow;
        }
        updateSliderPosition();
      }
      
      if (nextButton && prevButton) {
        nextButton.addEventListener('click', moveToNextSlide);
        prevButton.addEventListener('click', moveToPrevSlide);
      }

      let autoplayInterval = null;
      const isAutoplay = container.dataset.autoplay === 'true';
      const speed = parseInt(container.dataset.speed, 10);

      function startAutoplay() {
        if (isAutoplay && !autoplayInterval && totalSlides > getSlidesToShow()) {
          autoplayInterval = setInterval(moveToNextSlide, speed);
        }
      }

      function stopAutoplay() {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }

      container.addEventListener('mouseenter', stopAutoplay);
      container.addEventListener('mouseleave', startAutoplay);
      
      // Touch swipe functionality
      let touchStartX = 0;
      let touchEndX = 0;

      container.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay(); // Pause autoplay on touch
      }, { passive: true });

      container.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipeGesture();
        startAutoplay(); // Resume autoplay after swipe
      }, { passive: true });

      function handleSwipeGesture() {
        const swipeThreshold = 50; // Min distance for a swipe
        if (touchEndX < touchStartX - swipeThreshold) {
          moveToNextSlide();
        }
        if (touchEndX > touchStartX + swipeThreshold) {
          moveToPrevSlide();
        }
      }

      // Initialize slider
      updateSliderPosition();
      startAutoplay();

      window.addEventListener('resize', updateSliderPosition);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
